var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M42 22.609L24 4.28 6 22.61V45h36V22.609zm-38.427-1.81a2 2 0 00-.573 1.4V46a2 2 0 002 2h38a2 2 0 002-2V22.2a2 2 0 00-.573-1.402l-19-19.345a2 2 0 00-2.854 0l-19 19.345z"}));
}

Home.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Home;

Home.default = Home;
